import styled from '@emotion/styled'
import { Button } from 'components/button/Button'

export const SAddButton = styled(Button)`
  height: unset;
  padding: 1rem;

  & > span {
    display: flex;
    flex-direction: column;
    align-items: center;
    max-width: 100%;
    white-space: normal;

    & > svg {
      margin-bottom: 0.5rem;
    }
  }
`
